import { render } from "./InputHeader.vue?vue&type=template&id=37b743d3&scoped=true"
import script from "./InputHeader.vue?vue&type=script&lang=js"
export * from "./InputHeader.vue?vue&type=script&lang=js"

import "./InputHeader.vue?vue&type=style&index=0&id=37b743d3&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-37b743d3"

export default script